import { ClientJS } from 'clientjs';
import { StorageParams } from '../../../constants/StorageParams';

export class UserFingerprint {
    private firstWebVisitTs: string;
    private firstWebVisitRnd: string;
    private fingerPrintId: number;
    private clientJs: ClientJS;

    constructor(clientJs: ClientJS) {
        console.log('Fingerprint user start');
        this.clientJs = clientJs;
        this.firstWebVisitRnd = this.getRnd();
        this.firstWebVisitTs = this.getTs();
        this.fingerPrintId = this.getId();
    }

    public getTs(): string {
        const localFirstWebVisitTs = localStorage.getItem(StorageParams.FIRST_WEB_VISIT_TS);
        const cookieFirstWebVisitTs = $.cookie(StorageParams.FIRST_WEB_VISIT_TS);
        console.log('FIRST_WEB_VISIT_TS', cookieFirstWebVisitTs);
        if (!localFirstWebVisitTs && !cookieFirstWebVisitTs) {
            const ts = Math.floor(new Date().getTime() / 1000);
            this.firstWebVisitTs = `${ts}`;
            localStorage.setItem(StorageParams.FIRST_WEB_VISIT_TS, `${ts}`);
            $.cookie(StorageParams.FIRST_WEB_VISIT_TS, `${ts}`, {
                path: '/'
            });
        } else {
            this.firstWebVisitTs = (localFirstWebVisitTs)
                ? `${localFirstWebVisitTs}`
                : `${cookieFirstWebVisitTs}`;
        }
        return this.firstWebVisitTs;
    }

    public getRnd(): string {
        const localFirstWebVisitRnd = localStorage.getItem(StorageParams.FIRST_WEB_VISIT_RND);
        const cookieFirstWebVisitRnd = $.cookie(StorageParams.FIRST_WEB_VISIT_RND);
        if (!localFirstWebVisitRnd && !cookieFirstWebVisitRnd) {
            const ts = new Date().getTime();
            this.firstWebVisitRnd = `${ts}`;
            localStorage.setItem(StorageParams.FIRST_WEB_VISIT_RND, `${ts}`);
            $.cookie(StorageParams.FIRST_WEB_VISIT_RND, `${ts}`, {
                path: '/'
            });
        } else {
            this.firstWebVisitRnd = (localFirstWebVisitRnd) ? localFirstWebVisitRnd : `${cookieFirstWebVisitRnd}`;
        }
        return this.firstWebVisitRnd;
    }

    public getId(): number {
        this.fingerPrintId = this.clientJs.getFingerprint();
        return this.fingerPrintId;
    }
}
